import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle, XCircle, Loader2, Mail } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  
  const token = searchParams.get('token');

  useEffect(() => {
    if (token) {
      verifyEmail();
    } else {
      setStatus('error');
      setMessage('Token di verifica mancante');
    }
  }, [token]);

  const verifyEmail = async () => {
    try {
      const response = await axios.get(`${API}/auth/verify-email?token=${token}`);
      setStatus('success');
      setMessage(response.data.message);
    } catch (error) {
      setStatus('error');
      setMessage(error.response?.data?.detail || 'Errore durante la verifica');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#344B71] to-[#344B71] flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        className="w-full max-w-md"
      >
        <Card className="p-8 bg-white shadow-2xl rounded-2xl text-center">
          {status === 'verifying' && (
            <>
              <div className="w-20 h-20 bg-[#344B71]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <Loader2 className="w-10 h-10 text-[#344B71] animate-spin" />
              </div>
              <h1 className="text-2xl font-playfair font-bold text-[#344B71] mb-2">
                Verifica in corso...
              </h1>
              <p className="text-slate-600">
                Stiamo verificando il tuo indirizzo email
              </p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <CheckCircle className="w-10 h-10 text-emerald-600" />
              </div>
              <h1 className="text-2xl font-playfair font-bold text-[#344B71] mb-2">
                Email Verificata!
              </h1>
              <p className="text-slate-600 mb-6">
                {message}
              </p>
              <Button
                onClick={() => navigate('/auth')}
                className="w-full bg-[#344B71] hover:bg-[#344B71] text-white h-12 rounded-xl"
              >
                Vai al Login
              </Button>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-10 h-10 text-red-600" />
              </div>
              <h1 className="text-2xl font-playfair font-bold text-[#344B71] mb-2">
                Verifica Fallita
              </h1>
              <p className="text-slate-600 mb-6">
                {message}
              </p>
              <div className="space-y-3">
                <Button
                  onClick={() => navigate('/auth')}
                  className="w-full bg-[#344B71] hover:bg-[#344B71] text-white h-12 rounded-xl"
                >
                  Vai al Login
                </Button>
                <Button
                  onClick={() => navigate('/auth?resend=true')}
                  variant="outline"
                  className="w-full border-[#344B71] text-[#344B71] h-12 rounded-xl"
                >
                  <Mail className="w-4 h-4 mr-2" />
                  Richiedi nuovo link
                </Button>
              </div>
            </>
          )}
        </Card>
      </motion.div>
    </div>
  );
};

export default VerifyEmail;
